import { StanButton } from '@/components';
import { LuPlus, LuTrash2 } from 'react-icons/lu';

interface AudienceStepProps {
    recipientCount: number;
    hasSelectedTags: boolean;
    onOpenModal: () => void;
    onDeleteAudience: () => void;
}

export const AudienceStep = ({ recipientCount, hasSelectedTags, onOpenModal, onDeleteAudience }: AudienceStepProps) => {
    return (
        <div className='mb-6 flex w-full flex-col gap-6 sm:mb-8 sm:gap-8'>
            <h3>Who would you like to send this sequence to?</h3>

            {!hasSelectedTags ? (
                <StanButton
                    name='add-audience-button'
                    variant='outline'
                    size='sm'
                    onClick={onOpenModal}
                    icon={LuPlus}
                    className='w-full sm:w-fit'
                >
                    Add Audience
                </StanButton>
            ) : (
                <div className='flex flex-col gap-2'>
                    <label className='text-label-sm-bold'>Audience</label>
                    <div
                        className='border-neutral-subtle bg-canvas hover:bg-neutral-hover focus-within:ring-brand-subtle flex cursor-pointer items-center justify-between gap-3 rounded-md border px-3 py-2.5 transition-all duration-150 ease-in-out focus-within:ring-2 sm:px-4 sm:py-3'
                        onClick={onOpenModal}
                        tabIndex={0}
                        onKeyDown={e => {
                            // Don't trigger if the delete button is focused
                            if (e.target !== e.currentTarget) return;

                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onOpenModal();
                            }
                        }}
                        role='button'
                    >
                        <span className='text-body-sm text-brand-main truncate font-semibold'>
                            {recipientCount} Recipients
                        </span>
                        <button
                            onClick={e => {
                                e.stopPropagation();
                                onDeleteAudience();
                            }}
                            onKeyDown={e => {
                                // Prevent parent's onKeyDown from firing
                                e.stopPropagation();
                            }}
                            className='text-gray hover:text-dark bg-neutral-subtle focus-visible:ring-brand-subtle cursor-pointer rounded-full p-1.5 transition-all duration-150 ease-in-out hover:scale-105 focus-visible:ring-2 focus-visible:outline-none sm:p-2'
                            aria-label='Deselect audience'
                        >
                            <LuTrash2 className='size-4 shrink-0 sm:h-5 sm:w-5' />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
